import React, { useState }          from 'react'
import { useTranslation }           from 'react-i18next'
import { useApi }                   from '../utils/api'
import {
  Autocomplete, Box, Button,
  Chip, Container, FormControl,
  Grid, InputLabel, Link,
  MenuItem, Paper, Select,
  Stack, TextField, Typography,
}                                   from '@mui/material'
import { useSnackbar }              from 'notistack'
import Page                         from '../ui/components/Page'
import { BaseBreadcrumbs }          from '../ui/components/BaseBreadcrumbs'
import Consts                       from '../consts'

export default function ZoneDayOffBatchPage () {
  const api = useApi()
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()

  const [type, setType] = useState(Consts.Zone.DayOff.typeHolidays)
  const [action, setAction] = useState(Consts.Zone.DayOff.actionAdd)
  const [days, setDays] = useState([])
  const [loading, setLoading] = useState(false)

  const onSubmit = async (e) => {
    e.preventDefault()
    if (days.length === 0) {
      enqueueSnackbar(t('Select at least one day'), { variant: 'warning' })
      return
    }
    setLoading(true)
    try {
      await api.zone.batchDayOff(type, action, days)
      enqueueSnackbar(t('Days off updated successfully'), { variant: 'success' })
    } catch (e) {
      console.log(e)
      enqueueSnackbar(t('Failed to update days off'), { variant: 'error' })
    } finally {
      setLoading(false)
    }
  }

  return (
    <Page title={t('Days off')}>
      <Container component="main">
        <BaseBreadcrumbs key={"breadcrumb-batch-dayoff"}
                         title={t('Days off')}
                         items={[]}
        />
        <Stack direction="row" alignItems="center" mb={3}>
          <Typography variant="h4" gutterBottom>{t('Days off')}</Typography>
        </Stack>
        <Grid component={'form'} onSubmit={onSubmit} item mb={4} xs={12}>
          <Paper sx={{ p: 3 }}>
            <Grid container spacing={3}>
              {/* Type select */}
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth variant="standard">
                  <InputLabel>{t('Type')}</InputLabel>
                  <Select value={type} onChange={(e) => setType(e.target.value)}>
                    <MenuItem value={Consts.Zone.DayOff.typeHolidays}>{t('Holidays')}</MenuItem>
                    <MenuItem value={Consts.Zone.DayOff.typeUnavailableDays}>{t('Unavailable days')}</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              {/* Action select */}
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth variant="standard">
                  <InputLabel>{t('Action')}</InputLabel>
                  <Select value={action} onChange={(e) => setAction(e.target.value)}>
                    <MenuItem value={Consts.Zone.DayOff.actionAdd}>{t('Add')}</MenuItem>
                    <MenuItem value={Consts.Zone.DayOff.actionRemove}>{t('Remove')}</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Autocomplete
                  multiple
                  id="off-days"
                  options={Consts.Zone.DayOff.predefinedList}
                  value={days}
                  onChange={(e, newValue) => {
                    setDays(newValue.filter(it => /(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[1,2])\./.test(it)))
                  }}
                  freeSolo
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip variant="outlined" label={option} {...getTagProps({ index })} />
                    ))
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      label={t('Days')}
                      helperText={type === Consts.Zone.DayOff.typeHolidays ? t('During this days is applied price defined for holidays') : t('Service is not available during this days')}
                    />
                  )}
                />
                <Link href={'#'} variant={'body2'} onClick={(e) => {
                  e.preventDefault()
                  let selectedDays = [...days]
                  Consts.Zone.DayOff.predefinedList.forEach((it) => {
                    if (selectedDays.indexOf(it) === -1) {
                      selectedDays.push(it)
                    }
                  })
                  setDays(selectedDays)
                }}>{t('Add all national days off')}</Link>
              </Grid>
              <Grid item xs={12}>
                <Box sx={{ mt: 1 }}>
                  <Button
                    type="submit"
                    variant="contained"
                    disabled={loading}
                  >
                    {loading ? t('Loading...') : t('Save')}
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Container>
    </Page>
  )
}
